/**
 * <PaymentBlockedDialog> — « Ton abonnement n'a pas été payé ! », la boîte de l'élève (template).
 *
 * La seule à porter ces mots. L'élève la lit quand il touche une séance suspendue (la page rend le
 * clic à l'appelant, `onBlockedSessionPress`) et quand son « GO ! » est cadenassé
 * (`<LiveAccessDialog>` la monte). Coquille seule sur `<ConfirmDialog>`.
 *
 * Sans lien de paiement (`onPay` absent), la boîte ANNONCE et ne garde que « Fermer » : un bouton
 * « Régulariser » qui n'ouvre rien serait une impasse.
 *
 * Le parent a la sienne, vouvoyée, nourrie par la machine de ses gestes ; les deux se rejoindront
 * au câblage.
 */
import React from "react"

import { ConfirmDialog } from "../../molecules/ConfirmDialog"

const TEXTS = {
    title: "Ton abonnement n'a pas été payé !",
    message: "Pour retrouver l'accès aux sessions LIVE, le paiement de l'abonnement doit être régularisé.",
    pay: "Régulariser le paiement",
    close: "Fermer",
}

export type PaymentBlockedDialogProps = {
    visible: boolean
    /** Ouvre le lien de paiement. ABSENT = aucun lien à ouvrir : la boîte ne garde que « Fermer ». */
    onPay?: () => void
    onClose: () => void
    testID?: string
}

export function PaymentBlockedDialog(props: PaymentBlockedDialogProps) {
    const { visible, onPay, onClose, testID } = props
    const canPay = onPay != null

    return (
        <ConfirmDialog
            visible={visible}
            title={TEXTS.title}
            message={TEXTS.message}
            confirmLabel={canPay ? TEXTS.pay : TEXTS.close}
            cancelLabel={TEXTS.close}
            hideCancel={!canPay}
            onConfirm={onPay ?? onClose}
            onCancel={onClose}
            danger={false}
            testID={testID}
        />
    )
}
